import React from 'react'
import { SvgIcon } from '../icons/SvgIcon'

interface Props {
  className?: string
}

export function LogoText({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 288 30" fill="currentColor">
      <path d="M.47.43H5.89V29.57H.47Z" />
      <path d="M50.05.43V29.57H45.6L29.53,9.84V29.57H24.16V.43h4.45L44.68,20.16V.43Z" />
      <path d="M74.19,5H64.54V.43H89.26V5H79.6V29.57H74.19Z" />
      <path d="M125.6,25v4.54H103.75V.43H125V5H109.16v7.57h14.07V17H109.16v8Z" />
      <path d="M161.82,14.67h5.12V26.28A16.41,16.41,0,0,1,161.69,29a20.07,20.07,0,0,1-6.16,1,16.59,16.59,0,0,1-8-1.94,14.33,14.33,0,0,1-5.62-5.35,14.7,14.7,0,0,1-2-7.7,14.72,14.72,0,0,1,2-7.7A14.32,14.32,0,0,1,147.52,2,16.82,16.82,0,0,1,155.61,0a17.71,17.71,0,0,1,6.66,1.21,13.17,13.17,0,0,1,5,3.54L163.9,8.09a11,11,0,0,0-8-3.33,11.36,11.36,0,0,0-5.47,1.29,9.46,9.46,0,0,0-3.75,3.62A10.45,10.45,0,0,0,145.29,15a10.31,10.31,0,0,0,1.35,5.25,9.77,9.77,0,0,0,3.75,3.66,11,11,0,0,0,5.43,1.33,11.72,11.72,0,0,0,6-1.5Z" />
      <path d="M203.52,29.57l-6-8.53c-.25,0-.62,0-1.12,0h-6.58v8.49h-5.41V.43h12a16.22,16.22,0,0,1,6.6,1.25,9.55,9.55,0,0,1,4.3,3.58,10,10,0,0,1,1.5,5.54,9.86,9.86,0,0,1-1.6,5.66,9.57,9.57,0,0,1-4.6,3.54l6.7,9.57Zm-2-23.06A8.3,8.3,0,0,0,196.2,5h-6.33V16.62h6.33a8.19,8.19,0,0,0,5.37-1.52,5.26,5.26,0,0,0,1.83-4.3A5.23,5.23,0,0,0,201.57,6.51Z" />
      <path d="M244.19,22.83H229.62l-2.87,6.74h-5.58L234.29.43h5.32l13.16,29.14h-5.66Zm-1.79-4.25L236.91,5.84l-5.45,12.74Z" />
      <path d="M266.88.43h5.41V25h15.24v4.58H266.88Z" />
    </SvgIcon>
  )
}
